import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsSoftwareRedirectRoute: InvariantJiraRoute = {
	// the following route should be non-exact, it will handle "index" and "404" cases
	name: 'classic-software-redirect',
	path: '/jira/software/c/projects/:projectKey/settings',
};
